import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { computed, h } from "vue";
import { useI18n } from "vue-i18n";
import { Avatar, Badge, Button, Dropdown, RecordsTable, Tooltip } from "@eudonet/opal";
import { TruncatedCell } from "@/shared/components/TruncatedCell";
export default /*@__PURE__*/ _defineComponent({
    __name: 'HouseholdCard',
    props: {
        household: {},
        canEdit: { type: Boolean },
        disabledTooltip: {}
    },
    emits: ["edit", "delete"],
    setup(__props) {
        const props = __props;
        const { t } = useI18n();
        const members = computed(() => [...props.household.members]);
        const headerSubtitle = computed(() => {
            const type = t(`contact.detail.relations.foyer.card.type.${props.household.type}`);
            const count = t("contact.detail.relations.foyer.card.memberCount", props.household.members.length);
            return `${type} · ${count}`;
        });
        const memberColumns = computed(() => [
            {
                id: "name",
                header: t("contact.detail.relations.foyer.table.name"),
                cell: (member) => h("div", { class: "flex items-center gap-2 min-w-0" }, [
                    h(Avatar, {
                        name: member.fullName,
                        size: "sm",
                        as: "span",
                        presentational: true,
                    }),
                    h(TruncatedCell, { text: member.fullName }),
                ]),
            },
            {
                id: "isPrincipal",
                header: t("contact.detail.relations.foyer.table.statut"),
                cell: (member) => member.isPrincipal
                    ? h(Badge, {
                        label: t("contact.detail.relations.foyer.table.principalBadge"),
                        theme: "yellow",
                        size: "sm",
                        showCloseIcon: false,
                        showLeftIcon: true,
                    })
                    : h("span", { class: "text-sm text-(--text-text-body-subtle)" }, "-"),
            },
            {
                id: "role",
                header: t("contact.detail.relations.foyer.table.role"),
                cell: (member) => h("div", { class: "flex items-center gap-2 min-w-0" }, [
                    ...(member.isPrincipal
                        ? []
                        : [h("span", { class: "flex items-center justify-center size-4 shrink-0 text-(--text-text-body-subtle)" }, [
                                h("i", { class: "ri-arrow-go-back-line rotate-180 text-base leading-none", "aria-hidden": "true" }),
                            ])]),
                    h(TruncatedCell, { text: t(`contact.detail.relations.foyer.roles.${member.role}`) }),
                ]),
            },
            {
                id: "email",
                header: t("contact.detail.relations.foyer.table.email"),
                cell: (member) => member.email
                    ? h(TruncatedCell, { text: member.email })
                    : h("span", { class: "text-sm text-(--text-text-body-subtle)" }, "-"),
            },
        ]);
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(RecordsTable), {
                icon: "ri-home-4-line",
                title: __props.household.name,
                subtitle: headerSubtitle.value,
                columns: memberColumns.value,
                data: members.value,
                "min-width": 500
            }, {
                actions: _withCtx(() => [
                    _createVNode(_unref(Tooltip), {
                        text: __props.disabledTooltip,
                        disabled: __props.canEdit,
                        tabindex: !__props.canEdit ? 0 : undefined
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_unref(Button), {
                                variant: "secondary",
                                size: "sm",
                                "icon-only": "",
                                "icon-left": "ri-pencil-line",
                                "aria-label": _ctx.$t('common.edit'),
                                disabled: !__props.canEdit,
                                onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('edit')))
                            }, null, 8 /* PROPS */, ["aria-label", "disabled"])
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["text", "disabled", "tabindex"]),
                    _createVNode(_unref(Dropdown), {
                        "menu-align": "right",
                        items: [
                            {
                                label: _ctx.$t('common.delete'),
                                icon: 'ri-delete-bin-line',
                                danger: true,
                                onClick: () => _ctx.$emit('delete'),
                            },
                        ]
                    }, {
                        trigger: _withCtx(({ triggerProps }) => [
                            _createVNode(_unref(Tooltip), {
                                text: __props.disabledTooltip,
                                disabled: __props.canEdit,
                                tabindex: !__props.canEdit ? 0 : undefined
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_unref(Button), _mergeProps(triggerProps, {
                                        variant: "secondary",
                                        size: "sm",
                                        "icon-only": "",
                                        "icon-left": "ri-more-line",
                                        "aria-label": _ctx.$t('contact.detail.relations.foyer.card.moreActions'),
                                        disabled: !__props.canEdit
                                    }), null, 16 /* FULL_PROPS */, ["aria-label", "disabled"])
                                ]),
                                _: 2 /* DYNAMIC */
                            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["text", "disabled", "tabindex"])
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["items"])
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["title", "subtitle", "columns", "data"]));
        };
    }
});
